import { useLocation, useParams } from 'umi'

type LocationState = import('history').LocationState
type ILocation<S> = import('history').Location<S>
type IRouteQuery<S> = ILocation<S> & {
  query: Record<string, string>
  params: Record<string, string>
}

function useRouteQuery<S = LocationState>(): IRouteQuery<S> {
  const params = useParams()
  const query = useLocation<S>()
  return <IRouteQuery<S>>{
    ...query,
    params,
  }
}

export default useRouteQuery
